const contextPath = window.CONTEXT_PATH || '';

export const LOCATION_COOKIE = 'cookie_customer_location';
export const ZIP_REGEX = /(\d{5})/;
export const CA_POSTAL_REGEX = /^(?![DdFfIiOoQqUuWwZz])[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
export const legacyServicesPath = `${contextPath}/services`;
export const servicesPath = `${contextPath}/api/v2`;
export const CODE_TYPE_AKAMAI = 'AKAMAI';
export const CODE_TYPE_FALLBACK = 'FALLBACK';
export const CODE_TYPE_URL = 'URL';
export const CODE_TYPE_CUST_LOCATION = 'LOCATION';

export const CLASSNAME_UPDATING = 'container--updating';
